import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PrescriptionsService {
  static readonly REPORT_UPLOAD_MAX_BYTES = 20 * 1024 * 1024;
  static readonly REPORT_UPLOAD_MAX_MB = 20;
  static readonly TEXT_REPORT_MAX_LENGTH = 20000;

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  getPrescriptions(payload: (string | null) = null) {
    return this.http.get(
      // this.common.getBaseUrl() + 'patients.php?action=PatientsList' + (payload ? '&list=all' : '')
      this.apiUrl + '/prescription', this.getAuthHeaders()
    );
  }

  addPrescriptions(payload: any) {
    // return this.http.post('/api/destinations', destination);
    payload["action"] = "addPatients";
    // return this.http.post(this.common.getBaseUrl() + 'patients.php', payload);
    return this.http.post(this.apiUrl + '/prescription', payload, this.getAuthHeaders());
  }

  updatePrescriptions(payload: any) {
    payload["action"] = "updatePatients";
    // return this.http.put(this.common.getBaseUrl() + 'patients.php', payload);
    return this.http.put(this.apiUrl + '/prescription/' + payload.id, payload, this.getAuthHeaders());
  }

  deletePrescriptions(payload: any) {
    payload["action"] = "deletePatients";
    return this.http.put(this.common.getBaseUrl() + 'patients.php', payload);
  }

  getLatestPrescription(patientId: number) {
    return this.http.get(this.apiUrl + '/prescription/latest?patient_id=' + patientId, this.getAuthHeaders());
  }

  getPrescriptionsByPatientId(
    patientId: number,
    options?: { page?: number; per_page?: number }
  ) {
    let params = new HttpParams();
    if (options?.page) {
      params = params.set('page', String(options.page));
    }
    if (options?.per_page) {
      params = params.set('per_page', String(options.per_page));
    }

    return this.http.get(this.apiUrl + '/patients/' + patientId + '/prescriptions', {
      ...this.getAuthHeaders(),
      params
    });
  }

  uploadReports(formData: FormData) {
    return this.http.post(this.apiUrl + '/reports/upload', formData, this.getAuthHeaders());
  }

  buildReportUploadFormData(payload: {
    patient_id: number;
    files?: File[];
    prescription_id?: number;
    report_type?: string;
    source_type?: string;
    report_date?: string;
  }): FormData {
    const formData = new FormData();
    formData.append('patient_id', String(payload.patient_id));

    if (payload.prescription_id) {
      formData.append('prescription_id', String(payload.prescription_id));
    }
    if (payload.report_type) {
      formData.append('report_type', payload.report_type);
    }
    if (payload.source_type) {
      formData.append('source_type', payload.source_type);
    }
    if (payload.report_date) {
      formData.append('report_date', payload.report_date);
    }

    (payload.files || []).forEach((file) => {
      formData.append('files[]', file, file.name);
    });

    return formData;
  }

  uploadTextReport(payload: {
    patient_id: number;
    prescription_id?: number;
    report_title?: string;
    report_text: string;
    report_type?: string;
  }) {
    const formData = new FormData();
    formData.append('patient_id', String(payload.patient_id));
    if (payload.prescription_id) {
      formData.append('prescription_id', String(payload.prescription_id));
    }
    if (payload.report_title) {
      formData.append('report_title', payload.report_title);
    }
    if (payload.report_type) {
      formData.append('report_type', payload.report_type);
    }
    formData.append('report_text', payload.report_text);
    return this.uploadReports(formData);
  }

  getReportsByPatientId(
    patientId: number,
    options?: { limit?: number; offset?: number; analyzedOnly?: boolean; includeText?: boolean },
  ) {
    let params = new HttpParams();

    if (options?.limit != null) {
      params = params.set('limit', String(options.limit));
    }

    if (options?.offset != null) {
      params = params.set('offset', String(options.offset));
    }

    if (options?.analyzedOnly) {
      params = params.set('analyzed_only', '1');
    }

    if (options?.includeText) {
      params = params.set('include_text', '1');
    }

    return this.http.get(this.apiUrl + '/reports/patient/' + patientId, {
      ...this.getAuthHeaders(),
      params,
    });
  }

  getReportById(reportId: number) {
    return this.http.get(this.apiUrl + '/reports/' + reportId, this.getAuthHeaders());
  }

  deleteReport(reportId: number) {
    return this.http.delete(this.apiUrl + '/reports/delete/' + reportId, this.getAuthHeaders());
  }

  getPrescriptionsByAppointments(appointmentIds: number[]) {
    return this.http.post(
      this.apiUrl + '/prescription/by-appointments',
      { appointment_ids: appointmentIds },
      this.getAuthHeaders()
    );
  }

  searchPrescriptionTitles(query: string) {
    let params = new HttpParams().set('q', query);
    return this.http.get<any>(this.apiUrl + '/prescription/search', {
      ...this.getAuthHeaders(),
      params
    });
  }
}
